export default "__VITE_ASSET__105fc65e__"